import styled from 'styled-components';
import SlickSlider, { Settings } from 'react-slick';

import Image from './Image';
import { sliderStyle } from './Slider';
import { ThemeProps } from '../lib/theme';
import { ReactComponent as Arrow } from '../public/icons/arrow.svg';

const Slider = styled(SlickSlider)`
  ${sliderStyle}
`;

const Wrapper = styled.div`
  text-align: center;
  width: calc(100% + 2rem);
  margin: 1rem -1rem;

  @media only screen and (min-width: 500px) {
    width: 100%;
    margin: 1rem auto ${(p) => p.theme.spacing(2)};
  }
`;

const ArrowWrapper = styled.div(
  ({
    theme: { colors, zIndex },
    direction,
    color,
    fromTop = '49%',
  }: ThemeProps & ArrowProps) => `
    position: absolute;
    top: ${fromTop};
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 50%;
    background: ${
      color === 'green'
        ? colors.mellowHighlightColor
        : colors.highlightBackground
    };
    display: flex!important;
    align-items: center;
    justify-content: center;
    z-index: ${zIndex.default};

    ${
      direction === 'prev'
        ? `
          transform: rotate(180deg); 
          left: 0.5rem;
          `
        : 'right: 0.5rem;'
    }
`,
);

interface ImageGalleryProps {
  images: {
    src: string;
    height: number;
    width: number;
  }[];
  settings?: Settings;
}

interface ArrowProps {
  direction?: 'prev' | 'next';
  className?: string;
  style?: { [key: string]: string };
  onClick?: () => void;
  color?: 'green' | 'light';
  fromTop?: string;
}

export const CustomArrow = ({
  direction = 'next',
  className,
  style,
  onClick,
  color,
  fromTop,
}: ArrowProps) => (
  <ArrowWrapper
    direction={direction}
    className={className}
    style={style}
    onClick={onClick}
    color={color}
    fromTop={fromTop}
  >
    <Arrow />
  </ArrowWrapper>
);

const defaultSliderSettings = {
  accessibility: true,
  adaptiveHeight: true,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 2500,
  infinite: true,
  cssEase: 'ease-in-out',
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  nextArrow: <CustomArrow />,
  prevArrow: <CustomArrow direction="prev" />,
};

const ImageSlider = styled(Slider).attrs({ settings: defaultSliderSettings })`
  padding: 0;
`;

const ImageGallery = ({ images, settings }: ImageGalleryProps) => {
  if (!images || (images && images.length < 1)) {
    return null;
  }

  return (
    <Wrapper>
      <ImageSlider {...{ ...defaultSliderSettings, ...settings }}>
        {images.map((image, i) => (
          <Image key={`image-slider-${i}`} {...image} />
        ))}
      </ImageSlider>
    </Wrapper>
  );
};

export default ImageGallery;
